import { Container, Paper, Stack, Typography } from "@mui/material"
import SuccessIcon from "@mui/icons-material/CheckCircle"
import { grey } from "@mui/material/colors"
import { TSaleStorage } from "../../../core/types/Sale"
import AsaasSeal from "../../../components/AsaasSeal"
import { useTranslation } from "react-i18next"

interface CardUpdatedSuccessProps {
  sale: TSaleStorage | undefined
}

const CardUpdatedSuccess = ({ sale }: CardUpdatedSuccessProps) => {
  const { t } = useTranslation()

  return (
    <Container component={"main"} maxWidth="md">
      <Stack direction="column" spacing={3} sx={{ pt: 8 }}>
        <Paper
          square={true}
          elevation={0}
          sx={{ width: "100%", borderRadius: 5 }}
        >
          <Stack
            direction="column"
            alignItems="center"
            justifyContent="center"
            width="100%"
            sx={{ py: { sm: 3, xs: 2 } }}
            spacing={2}
          >
            <Stack sx={{ px: { sm: 5, xs: 2 }, width: "100%" }}>
              <Paper
                square={true}
                elevation={0}
                sx={{
                  width: "100%",
                  borderRadius: 1,
                  backgroundColor: "#1E88E5",
                }}
              >
                <Stack
                  direction="row"
                  spacing={2}
                  alignContent="center"
                  alignItems="center"
                  sx={{ py: 3, px: { sm: 5, xs: 1 } }}
                >
                  <SuccessIcon sx={{ fontSize: "3.5em", color: "#212121" }} />
                  <Stack direction="column">
                    <Typography variant="h5">
                      {t("postPurchase.cardUpdated.hello", { name: sale?.customer.name })}
                    </Typography>
                    <Typography variant="h4" fontWeight={600}>
                      {t("postPurchase.cardUpdated.title")}
                    </Typography>
                  </Stack>
                </Stack>
              </Paper>
            </Stack>
            <Container maxWidth="sm">
              <Typography variant="body1" fontWeight={600} gutterBottom>
                {t("postPurchase.cardUpdated.ready")}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {t("postPurchase.cardUpdated.nextCharges")}
              </Typography>
            </Container>
          </Stack>
        </Paper>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          spacing={2}
        >
          <Container maxWidth="sm">
            <Stack direction="column" width="100%" sx={{ width: "100%" }}>
              <Typography variant="body1" fontWeight={600} gutterBottom>
                {t("postPurchase.needHelp")}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 3 }}>
                {t("postPurchase.talkToResponsible")}
              </Typography>

              <Typography variant="body1" gutterBottom>
                <strong>{t("postPurchase.sellerName")}</strong>
                {sale?.sellerName}
              </Typography>
              <Typography variant="body1">
                <strong>{t("postPurchase.sellerEmail")}</strong>
                {sale?.sellerEmail}
              </Typography>
            </Stack>
          </Container>
        </Stack>
        <AsaasSeal sx={{ pt: 3 }} />
      </Stack>
    </Container>
  )
}

export default CardUpdatedSuccess
